import React from 'react';
import { Dialog, DialogTitle, DialogActions, DialogContent, TextField, Button, Typography, SelectChangeEvent, Select, MenuItem, Divider } from '@mui/material';
import { DialogProps } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import AutocompleteCreatable from '../form_v2/lowLevelComponents/AutocompleteCreatable';
import { Box } from '@mui/system';
import AsyncButton from '../AsyncButton/AsyncButton';

export interface IDialog extends DialogProps {
    title: string
    isLoading: boolean;
    handleClose: () => void;
    onAccept: any;
    options?: any;
    contributors?: any;
}

export default function DialogAddContributor(props: IDialog) {
  const [contributorNickname, setContributorNickname] = React.useState<string>('');
  const [contributorBirthYear, setContributorBirthYear] = React.useState<string>('');
  const [connectorRole, setConnectorRole] = React.useState<string | number>('');
  const [contributorFullName, setContributorFullName] = React.useState<string | number>('');
  const [isContributorNew, setIsContributorNew] =React.useState<boolean>(false);

  const {open, handleClose, title, isLoading, onAccept, options, contributors } = props;  

  const handleSelectChange = (event: SelectChangeEvent<typeof connectorRole>) => {
    setConnectorRole(event.target.value);
  };

  const handleOnSumbit = (values: any, isNew: boolean) => {
    setIsContributorNew(isNew);
    setContributorFullName(values);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='dialog-title'
      >
        {title
          ? <DialogTitle id='dialog-title'>
            <Typography variant='h3'>{title}</Typography>
          </DialogTitle>
          : null
        }
        <Divider variant='fullWidth' sx={{mb: 2}} />
        <DialogContent>
          <Box mb={1}>
            <AutocompleteCreatable label={'Ονοματεπώνυμο'} contributorsList={contributors}
              onChange={handleOnSumbit}/>
          </Box>
          {isContributorNew === true && 
          <>
            <TextField
              label='Ψευδώνυμο'
              value={contributorNickname}
              onChange={(e) => setContributorNickname(e.target.value)}
              fullWidth
              margin='normal'
            />
            <TextField
              label='Χρονολογία Γέννησης'
              value={contributorBirthYear}
              type='number'
              onChange={(e) => setContributorBirthYear(e.target.value)}
              fullWidth
              margin='normal'
            />
          </>}
          <Box mt={2} mb={2}>
            <FormControl fullWidth>
              <InputLabel id='simple-select-label'>Ιδιότητα στο Έργο</InputLabel>
              <Select
                labelId='simple-select-label'
                id='simple-select'
                value={connectorRole}
                label='Ιδιότητα στο Έργο'
                onChange={handleSelectChange}
              >
                {options.map((option: any) => (
                  <MenuItem key={option.key} value={option.value}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined'
            sx={{mr: 2}}
            onClick={handleClose}>
            Ακύρωση
          </Button>
          <AsyncButton 
            title={'Υποβολή'} 
            isLoading={isLoading}
            onClick={() => 
              onAccept({
                contributorNickname, 
                contributorBirthYear, 
                connectorRole, 
                contributorFullName, 
                isContributorNew
              })}
            
          />
        </DialogActions>
      </Dialog>
    </>
  );
}